export default __webpack_public_path__ + "static/media/marvel.3678b312.jpeg";